import { z } from 'zod';
import type { ShigoUser } from './model';
import { ShigoRole } from './permissions';

// Membership-scoped grants from /users/me; no agency lookup endpoint is assumed.
export const assignedAgencySchema = z.object({
  id: z.union([z.string().trim().min(1), z.number().int().nonnegative()]).transform(String),
  name: z.string().trim().min(1),
});
export type AssignedAgency = z.infer<typeof assignedAgencySchema>;

export function assignedAgencies(user: ShigoUser | undefined) {
  return user?.roles.includes(ShigoRole.Agency) ? (user.agencies ?? []) : [];
}

export function agencyIdFromPath(pathname: string) {
  return /^\/a\/([^/]+)(?:\/|$)/.exec(pathname)?.[1] ?? null;
}

export function canAccessAgencyPath(user: ShigoUser, pathname: string) {
  const agencyId = agencyIdFromPath(pathname);
  return (
    Boolean(agencyId && assignedAgencies(user).some(({ id }) => id === agencyId)) &&
    /^\/a\/[^/]+(?:\/reporting\/(?:report-explorer|saved-reports)|\/campaigns\/(?:brands|supply|channel-groups|campaigns|line-items|creatives|overview|brands\/[^/]+\/details))?\/?$/.test(
      pathname,
    )
  );
}
